import { InMemoryCache } from "@apollo/client";

// Membership add-ons share one id across every membership model, but a
// percentage add-on has a different amount per model. Store them inside
// their model instead of as one normalized entity per id.
export const createCmpInMemoryCache = () =>
  new InMemoryCache({
    typePolicies: {
      ChamberMemberProMembershipAdditionalCostReturn: { keyFields: false },
      CmpPublicMembershipApplicationAdditionalCostReturn: { keyFields: false },
    },
  });
